import { MutationTree } from 'vuex';
import { RallyIntelligenceState } from '../types';

export const mutations: MutationTree<RallyIntelligenceState> = {
	DECREMENT_CREDITS(state) {
		state.creditsRemaining = Math.max(0, state.creditsRemaining - 1);
	}
};
